import { render, staticRenderFns } from "./BlendSupplier.vue?vue&type=template&id=db284af2"
import script from "./BlendSupplier.vue?vue&type=script&lang=js"
export * from "./BlendSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports